import { render, staticRenderFns } from "./MyYwY.vue?vue&type=template&id=2bc8a364&"
import script from "./MyYwY.vue?vue&type=script&lang=js&"
export * from "./MyYwY.vue?vue&type=script&lang=js&"
import style0 from "./MyYwY.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports